import { render } from "./ApiGuideAuthPage.vue?vue&type=template&id=6c480262"
import script from "./ApiGuideAuthPage.vue?vue&type=script&lang=js"
export * from "./ApiGuideAuthPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__